//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconTeam(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.47 5L10.79 3H2V17H4V5H9.86L11.53 7H20V19H2V21H22V5H12.47Z" fill="currentColor" /><path d="M10.25 12.5C11.0784 12.5 11.75 11.8284 11.75 11C11.75 10.1716 11.0784 9.5 10.25 9.5C9.42157 9.5 8.75 10.1716 8.75 11C8.75 11.8284 9.42157 12.5 10.25 12.5Z" fill="currentColor" /><path d="M15.75 12.5C16.5784 12.5 17.25 11.8284 17.25 11C17.25 10.1716 16.5784 9.5 15.75 9.5C14.9216 9.5 14.25 10.1716 14.25 11C14.25 11.8284 14.9216 12.5 15.75 12.5Z" fill="currentColor" /><path d="M14.9102 16H18.6402L17.9102 14H14.1802L14.9102 16Z" fill="currentColor" /><path d="M7.35986 16H13.3199L12.5899 14H8.08986L7.35986 16Z" fill="currentColor" /></svg>;
}
export default IconTeam;